export default {
  versions: 'プロジェクト',
  errorMessage: '編集に失敗しました',
  versionmanage: 'バージョン管理',
  versionName: 'バージョン名',
  creator: '作成者',
  hideVersion: 'バージョンを非表示にする',
  title: 'バージョンリスト',
  infoTitle: 'バージョン情報',
  versionEdit: 'バージョンの編集',
  deleteSuccessText: '削除完了',
  searchHeadText: '検索',
  createButton: 'プロジェクト作成',
  createDCOButton: '新しいDCOバージョンを作成',
  createMultiButton: '複数のプロジェクトを作成',
  deleteButton: '一括削除',
  downloadButton: '一括ダウンロード',
  channelName: 'チャネル：',
  platforms: 'プラットフォーム：',
  packageName: 'パッケージ名',
  productName: '製品名：',
  deleteConfirmButton: '削除',
  deleteConfirmText: '現在のバージョンを削除しますか？',
  deleteTitle: '削除を確認',
  deleteTips: '削除後、現在のバージョンは復元できません。',
  viewAllProduct: 'すべての製品を表示',
  language: '言語：',
  actionButton: {
    edit: '編集',
    copy: 'コピー',
    download: 'ダウンロード',
    preview: 'プレビュー',
    hide: '非表示',
    renew: '元に戻す',
    viewData: 'データの表示',
    dcoConfiguration: 'DCOの構成',
    push: 'プッシュ',
    pushLog: 'プッシュの履歴',
    pushdownloadLog: 'エクスポート＆ダウンロードの履歴',
    copyToMulti: '複数の組み合わせにコピー',
    copyToPs: 'コンテンツエディタにコピー',
    copyToDco: 'DCOにコピー',
    copyAllResource: 'すべてのリソースをダウンロードする',
  },
  table: {
    column: {
      action: '操作',
      id: '番号',
      versionCount: 'バージョン数',
      description: 'バージョン名',
      lang: '言語',
      createdTime: '作成時間',
      hide: 'バージョンを非表示にする',
      unPublished: '未公開',
    },
  },
  createBy: {
    mw: 'MW',
    mindworks: 'Mindworks',
    self: '私',
    placeholder: '作成者の選択',
  },
  channelSetting: {
    contentRating: '年齢選択',
    noContentRating: 'なし',
    contentRating8: '8歳以上',
    contentRating12: '12歳以上',
    contentRating16: '16歳以上',
  },
  materialInteractive: {
    singStep: 'シングルステップ',
    moreStep: 'ダブルステップ以上',
    realStep: {
      tips: 'トライアルプレイのステップ数の設定は素材の配信効果に影響しますので、正確に選択してください。',
    },
    modify: {
      tips: 'ゲームステップを変更した後、再ダウンロード/プッシュすると再度課金されます。',
    },
    gameStep: 'プレイアブル広告のステップ数',
    gameJourney: '完全なトライアルプロセス中のゲームステップの数',
    gameJourneyTips: 'ゲーム開始からアプリストア遷移までのインタラクション回数',
    download: 'ダウンロード',
  },
}
